"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";

import {
  uiDesignSystemsHeroData,
  uiDesignStatsData,
  uiDesignSolutionsAndProcessData,
  uiDesignPortfolioData,
  uiDesignTechnologiesData,
  uiDesignAboutData,
  uiDesignSystemsFaqs,
} from "src/utils/mock/uiDesignSystemsData";

import { caseStudies } from "src/utils/mock/caseStudies";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function UiDesignSystemsComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    return project.projectStatus?.toLowerCase() === "active";
  });

  const filteredData = {
    ...uiDesignPortfolioData,
    projects: {
      liveProjects: activeProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={uiDesignSystemsHeroData} />

      <TechStats stats={uiDesignStatsData} />

      <WhyChooseUs data={uiDesignSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={uiDesignTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About UI Design & Systems" sections={uiDesignAboutData} />
        </div>
      </section>
      <FAQSection faqs={uiDesignSystemsFaqs} />
      <CommonContactSection />
    </div>
  );
}
